import { FieldMap } from "./FieldMap";

export class NormalizeItem {
    public ID: number = -1;
    public Actions: string = '';
    public FieldMap: string = '';
}